import { translate } from 'services/i18n';

import { StyledBulkText } from './styles';

export const UnrevealedContactsState = ({ revealCredits }: { revealCredits: number }) => (
  <>
    <StyledBulkText>{translate('contacts.bulk.export_to_crm.preview_modal.subtitle.reveal')}</StyledBulkText>
    <StyledBulkText>
      {translate('contacts.bulk.export_to_crm.preview_modal.credits.reveal', {
        number: revealCredits,
      })}
    </StyledBulkText>
  </>
);
